/**
 * gbi-3d-tilt — mouse-tracked 3D card tilt.
 *
 * Usage: add data-tilt to any element. Optional data-tilt-max="<deg>" (default 8).
 * Disabled on touch devices and with prefers-reduced-motion.
 */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isTouch = matchMedia('(hover: none)').matches;
  if (reduceMotion || isTouch) return;

  function attach(el) {
    const max = parseFloat(el.dataset.tiltMax) || 8;
    let rafScheduled = false;
    let nextX = 0, nextY = 0;

    function apply() {
      rafScheduled = false;
      el.style.transform = `perspective(1000px) rotateX(${nextY.toFixed(2)}deg) rotateY(${nextX.toFixed(2)}deg)`;
    }

    function onMove(e) {
      const rect = el.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width;
      const py = (e.clientY - rect.top) / rect.height;
      nextX = (px - 0.5) * 2 * max;
      nextY = -((py - 0.5) * 2 * max);
      if (!rafScheduled) {
        rafScheduled = true;
        requestAnimationFrame(apply);
      }
    }

    function onLeave() {
      nextX = 0; nextY = 0;
      if (!rafScheduled) {
        rafScheduled = true;
        requestAnimationFrame(apply);
      }
    }

    el.addEventListener('mousemove', onMove);
    el.addEventListener('mouseleave', onLeave);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-tilt]:not([data-tilt-init])').forEach((el) => {
      el.setAttribute('data-tilt-init', '');
      attach(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.GBI = window.GBI || {};
  window.GBI.tilt = { init };
})();
